<template>
  <div class="container">

  </div>
</template>

<script>
// https://vuetifyjs.com/en/styles/transitions

export default {
  data: () => ({
    url: process.env.VUE_APP_REST
  }),
  created() {
    window.location.replace("https://sinergia.dnp.gov.co/siipo");
    //this.$router.push("https://sinergia.dnp.gov.co/siipo");
  },
};
</script>